import {Pagination} from "antd";
import {Values} from "./hook/filtered-data.hook";
import React, {ReactElement} from "react";
import Filter from "../filtered-table/filter/filter";
import {FieldGroupConfig} from "../../../models/filter/filter.group";

interface FilteredDataProps {
    data: Values<any>;
    render: (item: any) => ReactElement;
    filters: FieldGroupConfig[];
}

export const FilteredData: React.FC<FilteredDataProps> = ({data, render, filters}) => {

    return (
        <>
            <Filter
                config={filters}
                onUpdated={data.setFilters}
                onInit={data.onFiltersInit}
                defaultValue={data.snapshots}
            />
            {data.data.map(value => render(value))}
            {data.pagination ? (
                <Pagination
                    pageSize={data.pagination.limit}
                    current={data.pagination.page}
                    total={data.pagination.total}
                    showSizeChanger
                    pageSizeOptions={[2, 10, 20, 50, 100]}
                    onChange={data.onPageChange}
                />
            ) : null}
        </>
    )
}